var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10376",
    "data-name": "Group 10376",
    transform: "translate(-0.189 -0.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17158",
    "data-name": "Rectangle 17158",
    transform: "translate(0.189 0.434)",
    fill: "#fff",
    stroke: "red",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 29.5,
    height: 29.5,
    rx: 7.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(15.802 7.382) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M0,0V11.788",
    transform: "translate(5.894)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8920",
    "data-name": "Path 8920",
    d: "M0,0H11.788",
    transform: "translate(0 5.894)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.8d1c01a9.svg";
export { ForwardRef as ReactComponent };